import { apiDRSSubcontractorGeneralAssetsRemove } from '@src/apis/drs/drs-subcontractor-general-assets-remove'
import { apiDRSSubcontractorGeneralAssetsUpdate } from '@src/apis/drs/drs-subcontractor-general-assets-update'
import { useAppStore } from '@src/AppStore'
import CompCreateButton from '@src/components/Buttons/CreateButton'
import { PAETableMoreActionType } from '@src/components/Form/comps/ActionMenu'
import FormPAETable from '@src/components/Form/PAETable'
import Modal from '@src/components/FormModal/Modal'
import useModal from '@src/components/FormModal/useModal'
import FormPanel from '@src/components/FormPanel/FormPanel'
import { useSnackbar } from '@src/components/GlobalSnackbar'
import MarginTop from '@src/components/Layout/MarginTop'
import { DRSPageType, mapDRSPageTypeToRoleId } from '@src/modules/DRS/DRSPage'
import { useDRS } from '@src/modules/DRS/useDRS'
import { doubleUp } from '@src/modules/DRS/utils/doubleUp'
import { mapMoreActions } from '@src/modules/DRS/utils/mapMoreActions'
import { PAE } from '@src/types/drs/PAE'
import { SubcontractorGeneralAssetPAE } from '@src/types/drs/subcontractor/SubcontractorGeneral'
import { ProjectTypeId, normalizeProjectTypeId } from '@src/types/ProjectTypeId'
import React, { useState } from 'react'
import styled from 'styled-components'
import { getSupplierAgreementActivityRowData } from '../utils/getSupplierAgreementActivityRowData'
import { transformFromFormData } from '../utils/transformFromFormData'
import DRSSubcontractorGeneralAssetsFields, { DRSSubcontractorGeneralAssetRow } from './GeneralAssetsFields'

const NULL_VALUES = {
  comments: null,
  docketNumber: null,
  quantity: null,
  startTime: null,
  supplier: null,
  supplierAgreement: null,
}
const ZERO_VALUES = {
  comments: null,
  docketNumber: null,
  quantity: '0',
  startTime: null,
  supplier: null,
  supplierAgreement: null,
}

interface Props {
  projectTypeId: ProjectTypeId.Asphalt | ProjectTypeId.SpraySeal,
}

const CompDRSSubcontractorGeneralAssets = (props: Props) => {
  const {
    projectTypeId,
  } = props
  const normalizedType = normalizeProjectTypeId(projectTypeId)

  const { drs, drsId, drsPageType, refresh } = useDRS()
  const isPlan = drsPageType === DRSPageType.Plan
  const isEdit = drsPageType === DRSPageType.Edit
  const updatingColumn: PAE.Plan | PAE.Edit = isPlan ? PAE.Plan : PAE.Edit
  const { alertError, alertDone } = useSnackbar()

  const [open, modalData, openAndSetData, closeModal] = useModal<DRSSubcontractorGeneralAssetRow>({})
  const { depotId, stateId, serialId } = useAppStore()
  
  // Add a state to force re-render when data changes
  const [dataVersion, setDataVersion] = useState(0)
  
  // Force increment when refresh is called to ensure component re-renders
  const forceRefresh = async () => {
    await refresh()
    setDataVersion(prev => prev + 1)
  }
  
  if (drs === null || drs.subcontractor[normalizedType] === null) {
    return null
  }

  const handleSave = async (form: DRSSubcontractorGeneralAssetRow) => {
    const finalFormData = transformFromFormData(form, drs.jobDetails.date)
    if (modalData === null) {
      const retained = getRetained()
      update([
        ...retained,
        {
          [updatingColumn]: {
            ...finalFormData,
          }
        }
      ])
    } else {
      updateItemByValues(form, finalFormData)
    }
  }
  const handleRevert = async (form: DRSSubcontractorGeneralAssetRow) => {
    updateItemByValues(form, NULL_VALUES)
  }
  const handleMarkZero = async (form: DRSSubcontractorGeneralAssetRow) => {
    updateItemByValues(form, ZERO_VALUES)
  }
  const handleDelete = async (form: any[]) => {
    var recordsAPI = [];
    var formData =typeof form == 'object' && form.length > 0 ?  form : [form];
    const retained = getRetained();
    if (formData.length > 0) {
      if (retained.length == formData.length) {
        recordsAPI = retained;
      } else {
        for (var i = 0; i < formData.length; i++) {
          recordsAPI.push(retained[formData[i]['_no_']]);
        }
      }
    }
  console.log(`recordsAPI`);
  console.log(recordsAPI);
  console.log(`recordsAPI`);
    if (recordsAPI.length > 0)
      deleteRecords(recordsAPI);
  }
  const deleteRecords = async (data: any[]) => {
    try {
      await apiDRSSubcontractorGeneralAssetsRemove({
        drsId: drsId,
        normalizedType,
        assets: data,
        reqSid: serialId,
        reqRole: mapDRSPageTypeToRoleId(drsPageType),
      })
      await forceRefresh()
      closeModal()
      alertDone()
    } catch (e) {
      console.error('Error deleting general assets:', e)
      alertError()
    }
  }
  const handleDuplicate = async (form: DRSSubcontractorGeneralAssetRow) => {
    const retained = getRetained()
    update([
      ...retained,
      {
        [updatingColumn]: {
          ...NULL_VALUES,
          supplier: form.supplier,
          supplierAgreement: form.supplierAgreement,
        }
      }
    ])
  }

  const getRetained = () => {
    const retainedAssets = drs.subcontractor[normalizedType].generalAssets
    return retainedAssets
  }
  const updateItemByValues = (form: DRSSubcontractorGeneralAssetRow, values: any) => {
    const retained = getRetained()
    if (form._no_ === undefined || form._type_ === undefined) {
      return
    }
    const updatingIndex = form._no_
    const data = [
      ...retained.slice(0, updatingIndex),
      {
        ...retained[updatingIndex],
        [updatingColumn]: {
          ...values,
        }
      },
      ...retained.slice(updatingIndex + 1),
    ]
    update(data)
  }
  const update = async (data: any[]) => {
    try {
      await apiDRSSubcontractorGeneralAssetsUpdate({
        drsId: drsId,
        normalizedType,
        assets: data,
        reqSid: serialId,
        reqRole: mapDRSPageTypeToRoleId(drsPageType),
      })
      await forceRefresh()
      closeModal()
      alertDone()
    } catch (e) {
      console.error('Error updating general assets:', e)
      alertError()
    }
  }
  function getTableData() {
    if (drs === null) {
      return []
    }
    if (drs.subcontractor[normalizedType] === null) {
      return []
    }
    const assets: SubcontractorGeneralAssetPAE[] = drs.subcontractor[normalizedType].generalAssets
    // Ensure we're working with fresh data by creating a new reference
    const freshAssets = JSON.parse(JSON.stringify(assets))
    const tripled = doubleUp<SubcontractorGeneralAssetPAE>(freshAssets, drsPageType)
    const tripledWithActions = tripled.map((data: any) => mapMoreActions(data, drsPageType, undefined, [PAETableMoreActionType.Delete, PAETableMoreActionType.Duplicate]))

    return tripledWithActions
  }
  let finalFields = DRSSubcontractorGeneralAssetsFields
  return <Wrapper>
    <FormPanel title={`Subcontractor General`}>
      <FormPAETable<DRSSubcontractorGeneralAssetRow>
        key={`general-assets-${dataVersion}-${drs?.subcontractor[normalizedType]?.generalAssets?.length || 0}`}
        fields={finalFields}
        data={getTableData()}
        isSpecialDelete={true}
        showNo={true}
        editable={true}
        isSelectable={true}
        onEditRow={(row: DRSSubcontractorGeneralAssetRow) => {
          openAndSetData(getSupplierAgreementActivityRowData(row))
        }}
        showMoreActions={isPlan || isEdit}
        onRevert={handleRevert}
        onMarkZero={handleMarkZero}
        onDelete={handleDelete}
        onDuplicate={handleDuplicate}
      />
      {(isPlan || isEdit) &&
        <MarginTop>
          <CompCreateButton onClick={() => {
            openAndSetData(null)
          }}>
            Add New Asset
          </CompCreateButton>
        </MarginTop>
      }
    </FormPanel>

    {open &&
      <Modal<DRSSubcontractorGeneralAssetRow>
        maxWidth={'sm'}
        open={open}
        title='Subcontractor General Asset'
        data={{
          rowData: modalData,
          fields: finalFields,
          columns: [
            {
              title: 'Asset Information',
              fieldKeys: [
                'supplier',
                'supplierAgreement',
                'activity',
              ],
            },
            {
              title: '',
              fieldKeys: [
                'startTime',
                'quantity',
                'docketNumber',
                'comments',
              ],
            },
          ],
          extra: {
            depotId,
            stateId,
          }
        }}
        onSuccess={handleSave}
        onClose={closeModal}
        onCancel={closeModal}
      />
    }
  </Wrapper>
}

const Wrapper = styled.div`

`

export default CompDRSSubcontractorGeneralAssets